export default __webpack_public_path__ + "static/media/splash-pop.98f7df9a.jpg";